import { createSelector } from "reselect"
import { ReduxState } from "../common/types"
import { iTkModifier } from "../cached-data/types"

export const selectTkModifierTypes = (state: ReduxState): iTkModifier[] => state.current_user.company_tk_modifiers ?? []

export const selectTkModifierTypesById = createSelector(selectTkModifierTypes, tkModifierTypes =>
    tkModifierTypes.reduce<Record<number, iTkModifier>>((acc, tkModifierType) => {
        acc[tkModifierType.id] = tkModifierType
        return acc
    }, {})
)

/**
 * Maps each TK Modifier Type's `slug` (the key used in `modifier_active`/`WorkComponent.modifiers`,
 * which is the Picklist ID as a string for custom modifiers) to its `public_api_field_name`
 * (the key used in a LaborRate's `custom_modifier_<public_api_field_name>` fields).
 *
 * These are two independently-stored identifiers for the same modifier type. Rate matching
 * criteria are keyed by `public_api_field_name`, while timekeeping entries store modifier
 * values keyed by `slug`, so this map is needed to translate between the two before matching.
 */
export const selectTkModifierPublicApiFieldNameBySlug = createSelector(selectTkModifierTypes, tkModifierTypes =>
    tkModifierTypes.reduce<Record<string, string>>((acc, tkModifierType) => {
        acc[tkModifierType.slug] = tkModifierType.public_api_field_name
        return acc
    }, {})
)
